/* eslint-disable indent */
import React from 'react';
import Modal from 'react-modal';

import './index.scss';

Modal.setAppElement('#root');

class InstallLayover extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentWillReceiveProps(nextProps) {}

  componentDidMount() {}

  render() {
    const {
      modelopen,
      closeServiceModal,
      schedules,
      deleteServiceType,
      selectedData,
    } = this.props;
    return (
      <div>
        <Modal
          isOpen={modelopen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={closeServiceModal}
          className="Modal"
          overlayClassName="Overlay"
          contentLabel="Example Modal"
        >
          <div>
            <div className="pc-modal-header">
              <div className="title">Are you sure?</div>
              <button className="modal-close" onClick={closeServiceModal}>
                X
              </button>
              <div className="modal-description">
                You are about to delete a rule. This cannot be undone.
              </div>
              <div className="actions">
                <button
                  className="btn btn--primary btn--lg"
                  onClick={() => deleteServiceType(selectedData)}
                  disabled={schedules.deleteScheduleBlocks}
                >
                  {schedules.deleteScheduleBlocks ? 'DELETING..' : 'DELETE'}
                </button>
                <button
                  className="btn btn--secondary btn--lg"
                  onClick={closeServiceModal}
                >
                  CANCEL
                </button>
              </div>
            </div>
          </div>
          {this.props.children}
        </Modal>
      </div>
    );
  }
}

export default InstallLayover;
